module.exports = __webpack_public_path__ + "img/knu2_main0.e4ea52fb.jpg";